import React, { useContext, useEffect, useState } from 'react'
import Card from '../components/Card'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { MyContext } from '../context/Context'
import { dashboard_count } from '../api/api'
import { Link } from 'react-router-dom'

function Dashboard() {
    const { adminData } = useContext(MyContext);


    const [dashboardCount, setDashboardCount] = useState([]);
    useEffect(() => {
        fetch_dashboard_api();
    }, [])

   

    const fetch_dashboard_api = async () => {
        try {
            const res = await dashboard_count()
            setDashboardCount(res.data.data);
        } catch (error) {
            console.error("Dashboard Count error:", error);
        }
    }


    console.log(dashboardCount);

    return (
        <div className="wrapper">

            {/*navbar - Sidebar*/}
            <Navbar />
            <Sidebar />

            {/* Content Wrapper. Contains page content */}
            <div className="content-wrapper">

                {/* Content Header (Page header) */}
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Dashboard</h1>
                            </div>

                        </div>
                    </div>
                </div> {/* /.content-header */}

                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        
                        {/* Small boxes (Stat box) */}
                        <div className='row'>
                            <Card link={'/sub-orders'} count={dashboardCount?.sub_orders_today_count} title="Today's sub order" bg_color="#17a2b8" footer_color="#1591a5" icon="ion ion-android-calendar" />
                            <Card link={'/sub-orders'} count={dashboardCount?.sub_orders_tomorrow_count} title="Tomorrow's Sub orders" bg_color="#dc3545" footer_color="#c6303e" icon="ion ion-bag" />
                            <Card link={'/sub-orders'} count={dashboardCount?.sub_orders_next_two_days_count} title="Upcoming sub orders in 2 days" bg_color="#28a745" footer_color="#24963e" icon="ion ion-ios-alarm" />
                            <Card link={'/orders'} count={dashboardCount?.orders_count} title="Orders" bg_color="#ffc107" footer_color="#e5ad06" icon="ion ion-bag" />
                            <Card link={'/orders'} count={dashboardCount?.orders_this_month_count} title="This month orders" bg_color="#28a745" footer_color="#24963e" icon="ion ion-calendar" />
                            <Card link={'/stock-history'} count={dashboardCount?.current_stock} title="Current stock" bg_color="#17a2b8" footer_color="#1591a5" icon="ion ion-stats-bars" />
                            <Card link={'/customer'} count={dashboardCount?.users_count} title="Customers" bg_color="#dc3545" footer_color="#c6303e" icon="ion ion-ios-people" />
                        </div>

                        <ion-icon name="people-outline"></ion-icon>
                    </div>{/* /.container-fluid */}
                </section>{/* /.content */}


            </div>{/* /.content-wrapper */}

            {/* footer */}
            <Footer />

            {/* Control Sidebar */}
            <aside className="control-sidebar control-sidebar-dark">
                {/* Control sidebar content goes here */}
            </aside>
            {/* /.control-sidebar */}
        </div>
    )
}

export default Dashboard